import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-field-label" }
const _hoisted_3 = { class: "p-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnumToRadioButton = _resolveComponent("EnumToRadioButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.ObjectIsUpper")), 1),
    _createVNode(_component_EnumToRadioButton, {
      modelValue: _ctx.triggerOrActionToAdd.stateComparer,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.triggerOrActionToAdd.stateComparer = $event)),
      enum: _ctx.SceneStateComparer,
      "disabled-choices": _ctx.sceneStateComparerDisabledChoices
    }, null, 8, ["modelValue", "enum", "disabled-choices"]),
    (_ctx.triggerOrActionToAdd.stateComparer != _ctx.SceneStateComparer.None)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.ToUpper")), 1),
          _createVNode(_component_EnumToRadioButton, {
            modelValue: _ctx.triggerOrActionToAdd.shutterState,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.triggerOrActionToAdd.shutterState = $event)),
            enum: _ctx.SceneShutterState
          }, null, 8, ["modelValue", "enum"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}